var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTelegram2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.2394 3.58142L13.1269 13.5439C12.9674 14.2469 12.5519 14.4219 11.9614 14.0909L8.74238 11.7189L7.18938 13.2129C7.01738 13.3849 6.87388 13.5284 6.54238 13.5284L6.77388 10.2504L12.7394 4.85992C12.9989 4.62892 12.6829 4.50042 12.3364 4.73192L4.96138 9.37592L1.78638 8.38192C1.09588 8.16642 1.08338 7.69142 1.93038 7.35992L14.3489 2.57542C14.9239 2.35992 15.4269 2.70342 15.2394 3.58192V3.58142Z",
    fill: "#D0CBD0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegram2);
export default __webpack_public_path__ + "static/media/Telegram2.369135b885836ad3b045f7a2856ab0b4.svg";
export { ForwardRef as ReactComponent };